/* eslint-disable */
// Here eslint disable is use to avoid line width error
import React from "react";

const BasicCalendar = (props: { className?: string }) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="19.003"
    height="20.587"
    viewBox="0 0 19.003 20.587"
  >
    <path
      id="Tracé_374"
      data-name="Tracé 374"
      d="M21.42,3.584H18.252V2H16.669V3.584H10.334V2H8.751V3.584H5.584A1.588,1.588,0,0,0,4,5.167V21a1.588,1.588,0,0,0,1.584,1.584H21.42A1.588,1.588,0,0,0,23,21V5.167A1.588,1.588,0,0,0,21.42,3.584Zm0,17.42H5.584V9.918H21.42Zm0-12.669H5.584V5.167H8.751V6.751h1.584V5.167h6.334V6.751h1.584V5.167H21.42Z"
      transform="translate(-4 -2)"
      fill="rgba(12,31,64,0.4)"
    />
  </svg>
);

export { BasicCalendar };
